<template lang="html">
  <button
    @click="handleClick"
    :class="styleClasses"
    :disabled="disabled">
    <div v-if="(selfGuard || noGuard) && isWaiting"
         :class="spinnerClasses">
      <span :class="spanClasses"></span>
    </div>
    {{ btnLabel }}
  </button>
</template>

<script>
export default {
  props: {
    label: String,
    styleType: String,
    isWaiting: Boolean,
    noGuard: Boolean,
    disabled: Boolean,
    noUpperCase: Boolean
  },

  data: () => ({
    selfGuard: false,

    styleClassGroup: {
      default: { 'btn-default': true },
      link: { 'btn-link': true },
      primary: { 'btn-primary': true },
      info: { 'btn-info': true },
      infoBlock: { 'btn-info': true, 'btn-block': true },
      infoLink: { 'btn-outline-info': true },
      primaryLargeBlock: { 'btn-primary': true, 'btn-block': true, 'btn-lg': true }
    }
  }),

  computed: {
    styleClasses () {
      return {
        'squared-button': true,
        'btn': true,
        ...this.styleClassGroup[this.styleType],
        'disabled': this.isWaiting && this.selfGuard
      }
    },

    spanClasses () {
      return {
        'spinner-border': true,
        'spinner-border-sm': this.styleType !== 'primaryLargeBlock'
      }
    },

    spinnerClasses () {
      return this.styleType === 'primaryLargeBlock' ? 'squared-button-spinner-container' : 'squared-button-spinner-container-sm'
    },

    btnLabel () {
      return this.noUpperCase ? this.label : this.label.toUpperCase()
    }
  },

  watch: {
    isWaiting (status) {
      if (!status) this.selfGuard = false
    }
  },

  methods: {
    handleClick () {
      this.$emit('click')
      this.selfGuard = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../scss/breakpoints';

  .squared-button {
    font-family: 'Roboto-Regular-local', sans-serif;
    position: relative;

    @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
      font-size: 18px;
    }

    &-spinner-container {
      position: absolute !important;
      left: 50%;
      margin-left: -17px;
      top: 50%;
      margin-top: -16px;
    }

    &-spinner-container-sm {
      position: absolute !important;
      left: 50%;
      margin-left: -8px;
      top: 50%;
      margin-top: -14px;

      @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
        margin-top: -22px;
      }
    }
  }

  button {
    padding-left: 1rem;
    padding-right: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/SquaredButton.vue